import { useMemo } from 'react';
import { Input } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { CellFormatOptions } from '@octano/global-ui';
import { StudyPlanVersionOffer } from '../types';

export const useColumns = (
  onInterviewRequiredChange?: (offerId: number, isRequired: boolean) => void,
  disabled = false,
) => {
  const { t } = useTranslation('configuration/enrollment-and-tuition');

  return useMemo(
    () => [
      {
        columnName: 'offer',
        headerText: t('table.columns.offer'),
        tdClassName: 'text-left',
        thClassName: 'text-left',
        cellFormat: (options: CellFormatOptions<StudyPlanVersionOffer>) => {
          const { row } = options;
          return `${row.studyPlanVersion.name} - ${row.campus.name} - ${row.schedule.name}`;
        },
      },
      {
        columnName: 'isInterviewRequired',
        headerText: t('table.columns.requiresInterview'),
        tdClassName: 'text-center',
        thClassName: 'text-center',
        cellFormat: (options: CellFormatOptions<StudyPlanVersionOffer>) => {
          const { row } = options;
          return (
            <Input
              type="checkbox"
              className="g-checkbox-input"
              style={{ cursor: 'pointer' }}
              checked={row.isInterviewRequired || false}
              onChange={(e) => {
                if (onInterviewRequiredChange) {
                  onInterviewRequiredChange(row.id, e.target.checked);
                }
              }}
              disabled={disabled}
            />
          );
        },
      },
    ],
    [onInterviewRequiredChange, disabled, t],
  );
};
